export const getShowAccountMenu = (state) => state.showAccountMenu
